import script from "./CameraInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraInstructions.vue?vue&type=script&setup=true&lang=js"

import "./CameraInstructions.vue?vue&type=style&index=0&id=e06786f8&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e06786f8"]])

export default __exports__